import { render, staticRenderFns } from "./SteamTouchDress.vue?vue&type=template&id=9e603a5a&scoped=true&"
import script from "./SteamTouchDress.vue?vue&type=script&lang=js&"
export * from "./SteamTouchDress.vue?vue&type=script&lang=js&"
import style0 from "./SteamTouchDress.vue?vue&type=style&index=0&id=9e603a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e603a5a",
  null
  
)

component.options.__file = "SteamTouchDress.vue"
export default component.exports